module.exports = __webpack_public_path__ + "static/images/active-arrow.6a46c0d.png";